/**
 * Error raised when trying to reference element that is not present in a collection
 */
export class UnknownElementError extends Error {
    constructor() {
        super("Unknown element");
    }
}
